import {Component, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@node_modules/@angular/forms';
import {ProgramService} from '@services/program/program.service';
import {debounceTime, finalize, switchMap, tap} from '@node_modules/rxjs/internal/operators';
import {EventEmitter} from '@node_modules/@angular/core';
import {Program} from '@models/program';
import {BehaviorSubject, Observable, ObservableInput} from '@node_modules/rxjs';
import {ProgramSearchResultInterface} from '@interfaces/programSearchResult.interface';

@Component({
  selector: 'app-search-programs',
  templateUrl: './search-programs.component.html',
  styleUrls: ['./search-programs.component.scss']
})
export class SearchProgramsComponent implements OnInit {
  @Output() result =  new EventEmitter<{result: Program[], query: string}>();
  @Input() programsSubject:  BehaviorSubject<Program[]>;
  @Input() direct:  BehaviorSubject<string>;
  searchInExistingPrograms = true;
  searchExistingResults: Program[];
  programs: Program[] = [];
  searchForm: FormGroup;
  loading = true;

  constructor(
    private programService: ProgramService,
  ) {
    // this.searchExistingResults = this.programs.slice();
  }

  ngOnInit() {
    this.programsSubject.subscribe(
      resp => this.programs = resp
    );
    this.searchForm = new FormGroup({
      inputData: new FormControl(null)
    });
    this.direct.subscribe(
      resp => {
        if (resp === 'exist') {
          this.searchInExistingPrograms = true;
          this.searchForm.get('inputData').reset();
        }
        if (resp === 'all') {
          this.searchInExistingPrograms = false;
          this.result.next({result: [], query: ''});
          this.searchForm.get('inputData').reset();
          // console.log( this.searchForm.get('inputData'));
        }
      });
    let stringQuery = '';
    this.searchForm
      .get('inputData')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap((value) => {
          stringQuery = value ? value : '';
          !this.searchInExistingPrograms ? this.result.next({result: [], query: stringQuery}) : null;
        }),
        switchMap(value => {
          if (this.searchInExistingPrograms === true) {
            this.searchStudents(value);
          } else {
            if (value) {
              return this.programService.search(value)
                .pipe(
                  finalize(() => this.loading = false),
                );
            }
          }
            return new Observable(null);
          }
        )
      )
      .subscribe((resp: {data: any}) => {
        // console.log(resp);
        this.result.next({result: resp.data, query: stringQuery});
      });
  }
  searchStudents(value) {
    if (value) {
      // console.log(this.programs);
      this.result.next({result: this.programs.filter( program => !program.program_name.toLowerCase().search(value)), query: value});
    } else {
      this.result.next({result: this.programs, query: ''});
    }
  }
}
